<template>
  <div>
    <v-toolbar app fixed clipped-right dense class="top-bar elevation-1" :class="viewType">
        <!-- <img :src="require('@/assets/logo.png')" alt="ROLO" height="40" style="border-radius:0" /> -->
        <img :src="require('@/assets/digitory/Light_Transparent250.png')" alt="DigiPoS_KDS" height="40" width="40"
          style="border-radius: 0" class="ml-2" />
      <v-toolbar-title class="font-title-bold hidden-xs-only ml-0 mt-1">
        <strong>DigiPoS KDS</strong>
        <v-icon right color="primary">flaticon-pos-terminal</v-icon>
        &nbsp;{{ node }}
      </v-toolbar-title>

      <v-btn color="success" icon flat @click="changeView('notifications')" v-if="enableNotification" :class="{'active' : viewType === 'notifications' }">
        <v-icon>notifications</v-icon>
        <span v-show="notificationCount > 0" class="notification-count">{{notificationCount}}</span>
      </v-btn>

    <v-spacer></v-spacer>
      <v-btn
        class="hidden-sm-and-up"
        :class="{'active': showSearch }"
        icon
        @click="showSearch = !showSearch"
        v-if="enableSearch"
      >
        <v-icon color="primary">search</v-icon>
      </v-btn>

      <check-search-bar :disabled="viewType == 'bump-out'" class="hidden-xs-only" :search.sync="searchObj"></check-search-bar>
      <v-btn :class="{'active' : viewType === 'list' }"  icon @click="changeView('grid')"  v-if="listView">
        <v-icon color="success">apps</v-icon>
      </v-btn>

      <v-btn :class="{'active' : viewType === 'grid' }" v-if="!listView" icon @click="changeView('list')" >
        <v-icon  color="success">list</v-icon>
      </v-btn>

      <v-btn icon @click="changeView('bump-out')" class="outline"  :class="{'active' : viewType === 'bump-out' }">
        <v-icon  color="success">grading</v-icon>
      </v-btn>
      <v-btn icon @click="changeView('summary')" class="outline"  :class="{'active' : viewType === 'summary' }">
        <v-icon  color="success">open_in_new</v-icon>
      </v-btn>

      <v-btn
        :class="{'active' : this.itemList}"
        :disabled="viewType==='bump-out' || viewType === 'notifications' || viewType==='summary'"
        icon
        @click="navigate()"
      >
        <v-icon color="success" >fastfood</v-icon>
      </v-btn>

      <v-btn icon :class="{'active' : settings }" @click="settings = !settings">
        <v-icon  color="success">settings</v-icon>
      </v-btn>

      <User />
      
    </v-toolbar>

    <div v-if="enableSearch && showSearch">
      <check-search-bar :search.sync="searchObj" class="hidden-sm-and-up"></check-search-bar>
      <v-divider class="hidden-sm-and-up"></v-divider>
    </div>

    <div>
      <v-menu v-model="settings" :close-on-content-click="false" bottom origin="center center"
        transition="slide--transition" :position-y="menuY" :position-x="1300">
        <settings :settings.sync="settings"/>
      </v-menu>
    </div>
  </div>
</template>

<style slot-scope>
.top-bar .v-toolbar__content {
  padding: 0 12px 0 3px !important;
}

.top-bar .v-btn.active {
  background-color: #223345 !important;
}
</style>


<script>
import checkSearchBar from "@/components/searchbar";
import kitchenLine from "@/components/kitchenLine";
import Settings from "@/components/Settings.vue";
import User from "@/components/User.vue";

export default {
  name: "topBar",
  components: {
    "check-search-bar": checkSearchBar,
    "kitchen-line": kitchenLine,
    Settings,
    User
  },
  props: {
    app: Boolean,
    enableSearch: Boolean,
    search: {
      txt: String,
      selectedServiceTypes: Array,
      selectedStatus: Array,
      selectedItemStatus: Array
    },
    itemList: Boolean,
    line: Object,
    viewType: {
      type: String,
      default: "grid"
    }
  },
  data() {
    return {
      searchObj: {
        txt: "",
        selectedServiceTypes: [],
        selectedStatus: [],
        selectedItemStatus: [2, 3]
      },
      showSearch: false,
      userName: localStorage.getItem("userName"),
      node: localStorage.getItem("nodeId") || "",
      lineRestricted: JSON.parse(localStorage.getItem("isLineRestricted")),
      listView: false,
      // viewType: "grid",
      settings: false
    };
  },
  methods: {
    navigate() {
      this.$emit("update:itemList", !this.itemList);
    },
    changeView(view) {
      if (
        view !== "bump-out" &&
        view !== "notifications" &&
        view !== "summary"
      ) {
        if (
          this.viewType !== "bump-out" &&
          this.viewType !== "notifications" &&
          this.viewType !== "summary"
        ) {
          this.listView = !this.listView;
        }
        if (this.listView) {
          view = "list";
        } else {
          view = "grid";
        }
      }
      // this.viewType = view;
      this.$emit("view", view);
      return;
    },
    logout() {
      localStorage.removeItem("userId");
      localStorage.removeItem("userName");
      localStorage.removeItem("privileges");
      localStorage.removeItem("_columns");

      this.$router.push("/store/" + localStorage.getItem("storeId") + "/home");
    }
  },
  computed: {
    kitchenLine() {
      let line = JSON.parse(localStorage.getItem("kitchenLine"));

      if (line) return line.name;
      else "";
    },
    menuY() {
      return this.$vuetify.breakpoint.name == "xs" ? 97 : 49;
    },
    notificationCount() {
      return this.$store.getters.getNotificationCount;
    },
    enableNotification() {
      let { enable } = this.$store.getters.getNotificationConfig;
      return enable;
    }
  },
  watch: {
    searchObj(t) {
      this.$emit("update:search", t);
    }
  }
};
</script>
